import whitePebblesImg from "@/assets/products/white-pebbles-1.jpg";
import whitePebblesImg2 from "@/assets/products/white-pebbles-2.jpg";
import whitePebblesImg3 from "@/assets/products/white-pebbles-3.jpg";
import blackPebblesImg from "@/assets/products/black-garden-pebbles.jpg";

export interface GardenPebbleProduct {
  id: string;
  name: string;
  sku: string;
  price: number;
  pricePerKg: number;
  weight: string;
  stoneSize: string;
  finish: string;
  colour: string;
  image: string;
  images?: string[];
  description: string;
  fullDescription: string;
  applications: string[];
  features: string[];
  specs: { label: string; value: string }[];
  inStock: boolean;
  shopifyVariantId: string;
  metaTitle: string;
  metaDescription: string;
}

export const GARDEN_PEBBLE_PRODUCTS: GardenPebbleProduct[] = [
  {
    id: "white-garden-pebbles-20kg",
    name: "White Garden Pebbles 20kg Bag (20–30mm)",
    sku: "GP-WHITE-20KG",
    price: 15,
    pricePerKg: 0.75,
    weight: "20kg",
    stoneSize: "20–30mm",
    finish: "Tumbled",
    colour: "White",
    image: whitePebblesImg,
    images: [whitePebblesImg, whitePebblesImg2, whitePebblesImg3],
    description: "Premium decorative white garden pebbles ideal for landscaping, pathways, garden beds and feature areas.",
    fullDescription: "Our White Garden Pebbles are premium decorative stones perfect for modern landscaping projects. Their bright white tone enhances contrast in garden beds and outdoor spaces.",
    applications: [
      "Walkways",
      "Garden borders",
      "Decorative landscaping",
      "Pool surrounds",
      "Feature areas",
    ],
    features: [
      "Low maintenance",
      "Decorative landscaping solution",
      "Suitable for residential & commercial use",
    ],
    specs: [
      { label: "Bag Size", value: "20kg" },
      { label: "Stone Size", value: "20–30mm" },
      { label: "Finish", value: "Tumbled" },
      { label: "Suitable for", value: "Outdoor use" },
    ],
    inStock: true,
    shopifyVariantId: "gid://shopify/ProductVariant/47824634446065",
    metaTitle: "White Garden Pebbles 20kg Bag | $15 | Supreme Turf",
    metaDescription: "Buy premium white garden pebbles 20kg bag at $15. 20-30mm polished stones for landscaping, pathways & garden beds. Australia-wide delivery.",
  },
  {
    id: "black-garden-pebbles-20kg",
    name: "Black Garden Pebbles 20kg Bag (20–30mm)",
    sku: "GP-BLACK-20KG",
    price: 20,
    pricePerKg: 1.0,
    weight: "20kg",
    stoneSize: "20–30mm",
    finish: "Polished Black",
    colour: "Black",
    image: blackPebblesImg,
    description: "Premium polished black garden pebbles for decorative landscaping and modern outdoor designs.",
    fullDescription: "Our Black Garden Pebbles provide a bold and elegant landscaping solution. Their deep polished finish makes them perfect for contemporary gardens and feature designs.",
    applications: [
      "Pathways",
      "Pool areas",
      "Garden beds",
      "Decorative borders",
      "Modern landscape projects",
    ],
    features: [
      "Strong & durable",
      "Fade resistant",
      "Decorative finish",
      "Low maintenance",
    ],
    specs: [
      { label: "Bag Size", value: "20kg" },
      { label: "Stone Size", value: "20–30mm" },
      { label: "Finish", value: "Polished Black" },
      { label: "Suitable for", value: "Outdoor use" },
    ],
    inStock: true,
    shopifyVariantId: "gid://shopify/ProductVariant/47824634478833",
    metaTitle: "Black Garden Pebbles 20kg Bag | $20 | Supreme Turf",
    metaDescription: "Buy premium black garden pebbles 20kg bag at $20. 20-30mm polished stones for landscaping, pathways & garden beds. Australia-wide delivery.",
  },
];

export function getGardenPebbleById(id: string): GardenPebbleProduct | undefined {
  return GARDEN_PEBBLE_PRODUCTS.find(p => p.id === id);
}
